import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerTeamProfile from "../../controller/custom/TeamProfile";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPageTeamProfile: React.FC = () => {
    // Variable
    const controllerTeamProfile = new ControllerTeamProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerTeamProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerTeamProfile.getSelectOption && controllerTeamProfile.getValidationForm) {
        return (
            <div className="view_team_profile form" data-at_id="view_team_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerTeamProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerTeamProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value date"
                                                        data-at_id="input_latest_update"
                                                        name="latest_update"
                                                        label={controllerLocalization.getStorageMain.latest_update}
                                                        value={
                                                            controllerTeamProfile.getDataMain.latest_update
                                                                ? HelperSrc.localeFormat(new Date(controllerTeamProfile.getDataMain.latest_update))
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_latest_update_by_id"
                                                        name="latest_update_by_id"
                                                        label={controllerLocalization.getStorageMain.latest_update_by}
                                                        defaultValue={(() => {
                                                            for (const optionData of Object.values(
                                                                controllerTeamProfile.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (controllerTeamProfile.getDataMain.latest_update_by_id === optionDataTyped.value) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_name"
                                            name="name"
                                            label={controllerLocalization.getStorageMain.name}
                                            defaultValue={controllerTeamProfile.getDataMain.name || ""}
                                            required={controllerTeamProfile.getValidationForm.name.required}
                                            onChange={(event) => {
                                                if (controllerTeamProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerTeamProfile.getValidationForm.name.regex_pattern,
                                                        controllerTeamProfile.getValidationForm.name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="member_container">
                                        <div className="field_container">
                                            <MuiAutocomplete
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerTeamProfile.getSelectOption.user_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                value={(() => {
                                                    const currentStr =
                                                        controllerTeamProfile.getElementUserIdValue === "" && controllerTeamProfile.getDataMain
                                                            ? controllerTeamProfile.getDataMain.user_id
                                                            : controllerTeamProfile.getElementUserIdValue;

                                                    const opts = (() => {
                                                        const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                        for (const optionData of Object.values(controllerTeamProfile.getSelectOption.user_id)) {
                                                            optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                        }
                                                        return optionList;
                                                    })();

                                                    const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                    return selected;
                                                })()}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li
                                                                {...props}
                                                                data-at_id={`select_${option.display_name ? option.display_name : "select"}`}
                                                            >
                                                                {option.display_name || controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            data-at_id="input_user"
                                                            required={
                                                                controllerTeamProfile.getValidationForm
                                                                    ? controllerTeamProfile.getValidationForm.user_id.required
                                                                    : false
                                                            }
                                                            onChange={(event) => HelperSrc.checkRegexSelect(event.target.name, event.target.value)}
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.user
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="user_id"
                                                            defaultValue={
                                                                controllerTeamProfile.getElementUserIdValue === "" &&
                                                                controllerTeamProfile.getDataMain
                                                                    ? controllerTeamProfile.getDataMain.user_id !== undefined
                                                                        ? controllerTeamProfile.getDataMain.user_id
                                                                        : ""
                                                                    : controllerTeamProfile.getElementUserIdValue
                                                            }
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerTeamProfile.setElementUserIdValue) {
                                                        controllerTeamProfile.setElementUserIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                            <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                        </div>
                                        <div className="field_container">
                                            <Button
                                                className="button_primary"
                                                data-at_id="button_add_member"
                                                onClick={() => {
                                                    controllerTeamProfile.clickAddMember();
                                                }}
                                            >
                                                {controllerLocalization.getStorageMain.add_member}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="member_list">
                                        <p>{controllerLocalization.getStorageMain.member}</p>
                                        <ul>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerTeamProfile.getDataMain.member) {
                                                    let index = 1;

                                                    for (const [key, value] of Object.entries(controllerTeamProfile.getDataMain.member)) {
                                                        const alternateRow = Number(index) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <li className={`row ${alternateRow}`} data-at_id={`li_${value}`}>
                                                                {value}
                                                                <MuiDeleteIcon
                                                                    data-at_id="icon_delete"
                                                                    className="button_icon"
                                                                    onClick={() => controllerTeamProfile.clickRemove(key)}
                                                                />
                                                            </li>
                                                        );

                                                        index++;
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </ul>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerTeamProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerTeamProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerTeamProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageTeamProfile;
